import { useCallback } from "react";
import useTrackerContext from "./useTrackerContext";
import useGlobalContext from "./useGlobalContext";

export function useGoogleFlightsPriceAccuracyTag() {
  const { trackExternal } = useTrackerContext();
  return useCallback(
    (price: number, currency: string) => {
      trackExternal({
        type: "gtm-price-accuracy",
        args: [
          {
            event: "google-flights-flight-details-load",
            offerPrice: price,
            offerCurrency: currency
          }
        ]
      });
    },
    [trackExternal]
  );
}

export function useSkyScannerPriceAccuracyTag() {
  const { trackExternal } = useTrackerContext();
  const { features } = useGlobalContext();
  return useCallback(
    (price: number, currency: string) => {
      if (features["FLIGHTS_META_SKYSCANNER_SEND_LANDING_EVENT"]) {
        trackExternal({
          type: "gtm-price-accuracy",
          args: [
            {
              event: "skyscanner-flight-details-load",
              offerPrice: price,
              offerCurrency: currency
            }
          ]
        });
      }
    },
    [trackExternal, features]
  );
}
